import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function VueDeveloperPage() {
  return <FrontendDeveloperPage technology="vuejs" />;
}
